import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/invitation/activate")({
  component: lazyRouteComponent(() => import("./+ActivateInvitation")),
  validateSearch: object({
    token: fallback(optional(string(), ""), ""),
  }),
  beforeLoad: ({ search }) => {
    return {
      token: search.token,
    };
  },
  loader: ({ context }) => {
    if (!context.token) {
      throw redirect({
        to: "/",
      });
    }
  },
});
